var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "form",
    staticClass: "sign-up insicht insicht--fade-up",
    attrs: { tag: "form", novalidate: "" },
    on: {
      submit: function($event) {
        $event.preventDefault()
        return _vm.onSubmit.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _vm.titleText
              ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.titleText) } })
              : _vm._e(),
            _vm._v(" "),
            _vm.response.message
              ? _c("GeneralMessage", {
                  ref: "message",
                  attrs: {
                    message: _vm.response.message,
                    type: _vm.response.type
                  },
                  on: {
                    close: function($event) {
                      _vm.response.message = ""
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("ValidationProvider", {
              ref: "registerEmail",
              staticClass: "input-wrapper",
              attrs: {
                name: "email",
                rules: "required|email",
                tag: "div",
                customMessages: {
                  required: _vm.$t("forms.errors.fieldEmpty"),
                  email: _vm.$t("forms.errors.emailInvalid")
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      var invalid = ref.invalid
                      var validated = ref.validated
                      var dirty = ref.dirty
                      return [
                        _c("FormInput", {
                          attrs: {
                            type: "email",
                            name: "email",
                            autocomplete: "email",
                            placeholder: _vm.$t("forms.labels.email"),
                            label: _vm.$t("forms.labels.email"),
                            error: invalid && validated,
                            disabled: _vm.formLocked,
                            required: ""
                          },
                          model: {
                            value: _vm.formData.email,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "email", $$v)
                            },
                            expression: "formData.email"
                          }
                        }),
                        _vm._v(" "),
                        invalid && validated
                          ? _c("span", {
                              staticClass: "input-error",
                              domProps: { innerHTML: _vm._s(errors[0]) }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            _c("Button", {
              attrs: {
                type: "submit",
                level: "primary",
                text: _vm.$t("newsletter.unsubscribeButton"),
                disabled: _vm.formLocked
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }